import React from 'react';
import _ from 'underscore';
import { Nav, NavItem } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import isUrl from 'validate.io-uri';

import Loader from '../../../common/components/notifications/Loader';
import TargetTab from './TargetTab';
import AdsTab from './AdsTab';
import events from './manifest';
import Snack from '../../../common/components/SnackMessage';
import actionFromId from '../util';

const noop = function () {};

const DATE_FORMAT = 'YYYY-MM-DD';

/*
props.vast.data = {
    "campaignID": 28,
    "name": "some test campaign5",
    "description": null,
    "actionID": 5,
    "startDate": "2016-06-25 09:00:00",
    "endDate": "2016-06-27 09:00:00",
    "typeID": 3,
    "campaignAssets": [],
    "campaignCategoryIDs": null,
    "campaignEvents": null
  }

    typeID = 1 | 2 | 3 = ['global', 'category', 'event']

*/

function VastEdit (props) {
    var loading = props.vast.resolving.length > 0 && !props.vast.hasFetched;

    var updateResolving = props.vast.resolving.length > 0 &&
        props.vast.hasFetched;

    if (loading) {
        return <div className="vast-edit">
            <Loader message='Fetching'/>
        </div>;
    }

    var errQueues = [
        ['vast', props.vast.errors],
        ['events', props.events.errors],
        ['assets', props.assets.errors],
        ['categories', props.categories.errors]
    ];

    var msgs = props.vast.messages;

    // success message element
    function success (msg) {
        return <span>
            <span className="text-success" style={{ fontWeight: 'bold'}}>SUCCESS</span>
            {' ' + msg}
        </span>;
    }

    return <div className={'vast-edit ' + (updateResolving ? 'disabled' : '')}>
        <VastEditContent {...props} disabled={updateResolving} />

        {errQueues.map(function (q, i) {
            return <Snack isOpen={!!q[1].length} timeout={4000} key={i}
                message={(q[1][0] || {}).message || ''}
                onClose={_.compose(props.push, events[q[0]].shiftError)}
                type="error"
            />;
        })}

        <Snack isOpen={!!msgs.length} timeout={4000}
            message={success( (msgs[0] || {}).message ) || ''}
            onClose={_.compose(props.push, events.vast.shiftMessage)}
        />
    </div>;
}

// VastEdit.propTypes = {
//     activeTab: pt.number,
//     pendingEdits: pt.object,
//     events: pt.object.isRequired,
//     categories: pt.object.isRequired,

//     vast: pt.shape({
//         resolving: pt.array.isRequired,
//         data: pt.shape({
//             campaignID: pt.any,
//             name: pt.string,
//             description: pt.any,
//             actionID: pt.number,
//             startDate: pt.string,
//             endDate: pt.string,
//             typeID: pt.number,
//             campaignEvents: pt.any,
//             campaignCategoryIDs: pt.any,
//             campaignAssets: pt.any
//         }).isRequired,
//         errors: pt.array.isRequired
//     })
// };

VastEdit.defaultProps = {
    activeTab: 0,
    pendingEdits: {},
    vast: {
        resolving: [],
        hasFetched: false,
        errors: [],
        data: {
            campaignCategoryIDs: [],
            campaignEvents: [],
            campaignAssets: [],
            actionID: 0,
            name: ''
        },
        messages: []
    },
    events: {
        errors: [],
        data: [],
        resolving: []
    },
    categories: {
        errors: [],
        data: [],
        resolving: []
    },
    assets: {
        data: [],
        errors: []
    }
};


var tabViews = [TargetTab, AdsTab];

function Push (_push) {
    return function push (Ev) {
        return function (data) {
            _push(Ev(data));
        };
    };
}

function ActionCheckboxes (props) {
    return <div className="form-group">
        <label style={{ marginRight: '1em' }}>Ad position</label>
        {['pre', 'mid', 'post'].map(function (type, i) {
            return <div key={i} className="checkbox">
                <label>
                    <input
                        type="checkbox"
                        disabled={props.disabled}
                        checked={props.checked[i]}
                        onChange={function (ev) {
                            var _ev = {};
                            _ev[ev.target.value] = ev.target.checked;
                            props.onChange(_ev);
                        }}
                        value={type}
                    />
                    {type + '-roll'}
                </label>
            </div>;
        })}
    </div>;
}

// ActionCheckboxes.propTypes = {
//     onChange: pt.func,
//     checked: pt.array
// };
ActionCheckboxes.defaultProps = {
    onChange: noop,
    checked: [false, false, false]
};

function VastEditContent (props) {
    var push = Push(props.push);

    function handleReset (ev) {
        ev.preventDefault();
        props.push(events.reset());
    }

    function handleSave (ev) {
        ev.preventDefault();
        props.push(events.saveCampaign());
    }

    function handleTitleEdit (ev) {
        props.push(events.editTitle(ev.target.value));
    }

    var vastStartDate = moment(props.pendingEdits.startDate ||
        props.vast.data.startDate);
    var vastEndDate = props.pendingEdits.endDate !== undefined ?
        (props.pendingEdits.endDate ?
            moment(props.pendingEdits.endDate) :
            null) :
        props.vast.data.endDate === null ?
            props.vast.data.endDate :
            moment(props.vast.data.endDate);

    function handleStartDateChange (ev) {
        props.push(events.changeStartDate(ev.format(DATE_FORMAT)));
    }

    function handleEndDateChange (ev) {
        // can have null as an end date, which means it goes forever
        props.push(events.changeEndDate(
            ev.target && ev.target.value === 'none' ?
            (vastEndDate === null ?
                moment().format(DATE_FORMAT) :
                null) :
            events.changeEndDate(ev.format(DATE_FORMAT))
        ));
    }

    function adsAreValid (props) {
        var hasAssets = props.pendingEdits.campaignAssets === undefined ?
            (props.vast.data.campaignAssets || []).length :
            (props.pendingEdits.campaignAssets).length;

        return hasAssets &&
            assetsAreValid(props.pendingEdits.campaignAssets || []);
    }

    function assetsAreValid (assets) {
        return _(assets).every(function (asset) {
            return !!asset.clickURL && isUrl(asset.clickURL);
        });
    }

    function formIsValid (props) {
        return Object.keys(props.pendingEdits).length && adsAreValid(props) &&
            (props.pendingEdits.name !== undefined ?
                props.pendingEdits.name :
                props.vast.data.name
            );
    }

    var actionsChecked = actionFromId[(
        props.pendingEdits.actionID === undefined ?
            props.vast.data.actionID :
            props.pendingEdits.actionID
    )];

    var tabNav = <Nav
        bsStyle="tabs"
        activeKey={props.activeTab}
        onSelect={push(events.changeTab)}
    >
        <NavItem eventKey={0}>
            {'Campaign targets'}
        </NavItem>

        <NavItem eventKey={1}>
            {'Campaign videos' + (adsAreValid(props) ? '' : ' *')}
        </NavItem>
    </Nav>;

    return <div className="vast-page-content">

        <div className="vast-action-control callout clearfix">

            <div className="col-sm-12">
                <label>{'Title' + ( (props.pendingEdits.name === undefined &&
                    (!props.vast.data.name)) ? ' *' : '' )}</label>
                <input
                    className="form-control"
                    disabled={props.disabled}
                    type="text"
                    onChange={handleTitleEdit}
                    placeholder="Campaign title"
                    value={props.pendingEdits.name === undefined ?
                        props.vast.data.name :
                        props.pendingEdits.name
                    }
                />
            </div>

            <div className="col-sm-12"><hr/></div>

            <div className="col-sm-12">
                <ActionCheckboxes
                    disabled={props.disabled}
                    onChange={push(events.changeAction)}
                    checked={actionsChecked}
                />
            </div>

            <div className="form-group clearfix">

                <div className="col-sm-6">
                    <div className="input-group" style={{
                        marginTop: '1.8em'
                    }}>
                        <span className="input-group-addon">Campaign start date</span>
                        <DatePicker
                            disabled={props.disabled}
                            showYearDropdown
                            showMonthDropdown
                            peekNextMonth
                            className="form-control"
                            dateFormat="MM/DD/YYYY"
                            selected={vastStartDate}
                            onChange={handleStartDateChange}
                        />
                    </div>
                </div>

                <div className="col-sm-6">
                    <div>
                    <label>
                        <input
                            type="checkbox"
                            disabled={props.disabled}
                            checked={vastEndDate === null}
                            onChange={handleEndDateChange}
                            value={'none'}
                        />
                        {' ' + 'no end date'}
                    </label>
                    </div>

                    <div className="input-group">
                        <span className="input-group-addon">
                            Campaign end date
                        </span>

                        <DatePicker
                            disabled={vastEndDate === null}
                            showYearDropdown
                            showMonthDropdown
                            peekNextMonth
                            className="form-control"
                            dateFormat="MM/DD/YYYY"
                            selected={vastEndDate}
                            onChange={handleEndDateChange}
                        />
                    </div>
                </div>

            </div>

            <div className="col-sm-12">
                <hr/>
            </div>

            <div className="col-sm-12 text-right">
                <ul className="form-group list-inline">
                    <li>
                        <button className="btn btn-default"
                            disabled={!Object.keys(props.pendingEdits).length}
                            onClick={handleReset}
                        >
                            Reset
                        </button>
                    </li>
                    <li>
                        <button className="btn btn-primary"
                            disabled={!formIsValid(props) ||
                                !Object.keys(props.pendingEdits).length}
                            onClick={handleSave}
                        >
                            Save
                        </button>
                    </li>
                </ul>
            </div>

            {tabNav}
            {tabViews[props.activeTab](props)}

        </div>

    </div>;
}

VastEditContent.defaultProps = {
    disabled: false
};

export default VastEdit;
